<template>
  <PageLoading :is-loading="isLoading"></PageLoading>
  <SideComponent @scrollto="scroll"></SideComponent>
	<NewIndexSiteLayout>
  <div class="container" ref="viewBox">
    <div id="content" class="content" ref="content">
      <Loading :is-loading="isListLoading"></Loading>
      <div v-if="showWeeklyPickBack || taleDetail.title" class="curated-wrap">
        <button
          v-if="showWeeklyPickBack"
          type="button"
          class="curated-back-btn"
          @click="goWeeklyPickList"
        >
          ‹ 返回本周精选
        </button>
        <section v-if="taleDetail.title" class="section">
          <div class="ar-content">
            <div style="font-family: 黑体, SimHei; font-size: 24px;font-weight:bold;">{{ taleDetail.title }}</div>
            <div
              v-if="taleDetail.description"
              style="font-family: 黑体, SimHei; font-size: 14px;color:#9b9b9b;margin:12px 0;"
            >
              {{ taleDetail.description }}
            </div>
            <div
              class="html-content"
              style="margin-top: 20px;"
              id="html-content"
              v-html="taleDetail.content"
            ></div>
          </div>
        </section>
      </div>
    </div>
    <Footer />
  </div>
  </NewIndexSiteLayout>
</template>

<script>
import curated_article from './curated_article_controller';
export default curated_article;
</script>

<style src="@/assets/css/publish_detail.css" scoped></style>
<style scoped>
.curated-wrap {
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
}
.curated-back-btn {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  margin: 20px 10px 12px;
  padding: 0;
  border: none;
  background: transparent;
  color: rgba(223, 58, 8, 1);
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.curated-back-btn:hover {
  opacity: 0.8;
}
</style>
